import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import { type ItemType } from 'antd/es/menu/interface';
import { useTranslation } from 'react-i18next';

import { type TDropdownAction } from 'components/DataTable/types';

type AdditionalActionsProps = {
  additionalItems: TDropdownAction[];
};

export const AdditionalActions: React.FunctionComponent<AdditionalActionsProps> = ({
  additionalItems = [],
}) => {
  const { t } = useTranslation();
  // menu items for 'Actions' dropdown
  const menuItems: ItemType[] = [
    ...additionalItems.map(item => {
      const { content, onClick, disabled, hoverable = true } = item;
      return {
        label: content,
        onClick,
        disabled,
        ...(hoverable ? {} : { className: 'not-hoverable' }),
      };
    }),
  ]
    .filter(Boolean)
    .map((item, index) => {
      return { ...item, key: index };
    });

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomLeft">
      <Button data-testid="datatable-actions-button">
        {t('table.actions', 'Actions')} <DownOutlined />
      </Button>
    </Dropdown>
  );
};
